import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { mainNav } from '../../data/navigation';
import { Logo } from '../brand/Logo';
export function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'error' | 'success'>('idle');
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    setStatus(/^\S+@\S+\.\S+$/.test(email) ? 'success' : 'error');
  };
  return <footer className="bg-berry text-white" data-id="element-193" data-mp="3s25b894lpdgf">
      <div className="mx-auto max-w-7xl px-5 pb-8 pt-14 lg:px-8" data-id="element-194" data-mp="3s13vvsgjy4sw">
        <div className="flex flex-col gap-10 lg:flex-row lg:items-end lg:justify-between" data-id="element-195" data-mp="3n2srhx910mi2">
          <div data-id="element-196" data-mp="3j2ihm9i45bxx">
            <Logo size="lg" sub="" data-id="element-197" data-mp="3j30cp2t1hk49" />
            <p className="mt-4 text-sm uppercase tracking-[0.3em] text-white/60" data-id="element-198" data-mp="3izw31pwt1w67">Beauty, made personal.</p>
          </div>

          <div className="w-full max-w-md" data-id="element-199" data-mp="393t40sx92dnh">
            <p className="text-sm font-medium" data-id="element-200" data-mp="39541yc40kr6o">10% korting op je eerste bestelling</p>
            {status === 'success' ? <p className="mt-3 flex h-12 items-center gap-2 text-sm" role="status" data-id="element-201" data-mp="2kb08jiahd0xs">
                <CheckIcon className="h-4 w-4 text-blush" data-id="element-202" data-mp="2p54hg73b3j1i" /> Check je inbox voor je code.
              </p> : <form onSubmit={submit} noValidate className="mt-3" data-id="element-203" data-mp="2baln8ixinlua">
                <label htmlFor="nl-email" className="sr-only" data-id="element-204" data-mp="2gc16c5g4via1">E-mailadres</label>
                <div className="flex h-12 items-center rounded-full border border-white/25 pl-5 pr-1 focus-within:border-white" data-id="element-205" data-mp="3425bwicvts3o">
                  <input id="nl-email" type="email" value={email} onChange={e => {
                setEmail(e.target.value);
                if (status === 'error') setStatus('idle');
              }} placeholder="jouw@email.nl" aria-invalid={status === 'error'} className="min-w-0 flex-1 bg-transparent text-sm text-white placeholder:text-white/45 focus:outline-none" data-id="element-206" data-mp="381w7czdcswej" />
                  <button type="submit" className="grid h-10 w-10 place-items-center rounded-full bg-white text-berry transition-colors duration-150 hover:bg-blush" aria-label="Aanmelden" data-id="element-207" data-mp="zimce7x1bn4v">
                    <ArrowRightIcon className="h-4 w-4" data-id="element-208" data-mp="ptkto9z3urn7" />
                  </button>
                </div>
                {status === 'error' && <p className="mt-2 text-xs text-blush" data-id="element-209" data-mp="kvay3y9gxp12">Vul een geldig e-mailadres in.</p>}
              </form>}
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-5 border-t border-white/15 pt-6 text-sm lg:flex-row lg:items-center lg:justify-between" data-id="element-210" data-mp="fxhsb6c2ux1b">
          <nav aria-label="Footer" data-id="element-211" data-mp="6v8nmx3hpxvu">
            <ul className="flex flex-wrap gap-x-6 gap-y-2" data-id="element-212" data-mp="6wb9gqlyha4w">
              {[...mainNav, {
              to: '/living',
              label: 'AMIRA Living'
            }, {
              to: '/over-amira',
              label: 'Ons verhaal'
            }].map(l => <li key={l.to} data-id="element-213" data-mp="21915bdvvwtex">
                  <Link to={l.to} className="text-white/65 transition-colors duration-150 hover:text-white" data-id="element-214" data-mp="28s0obiffoixr">{l.label}</Link>
                </li>)}
            </ul>
          </nav>
          <p className="text-white/50" data-id="element-215" data-mp="2dor2g07oh4gj">© 2026 AMIRA Beauty · iDEAL · Klarna · PayPal</p>
        </div>
      </div>
    </footer>;
}